import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Paper,
  Modal,
  Box,
} from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Person as PersonIcon,
  Schedule as ScheduleIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon,
  History as HistoryIcon,
  AttachMoney as AttachMoneyIcon,
  Search as SearchIcon,
} from '@mui/icons-material';
import { Editor } from 'react-draft-wysiwyg';
import moment from 'moment';
import {
  editarTarea,
  obtenerDireccionesTareas,
  obtenerTelefonosTareas,
  obtenerTareasNotificacion,
  obtenerTareasPresupuestoG,
} from '../../actions/TareasAction';
import { useStateValue } from '../../contexto/store';
import { useHistory } from 'react-router-dom';
import TTareas from './TTareas.js';
// import { obtenerPresupuestoPorId } from '../../actions/PresupuestosAction.js';
import TFacturasTareas from '../GestionDeCobranzas/TFacturasTarea.js';
import {
  modificarFactura,
  obtenerCobranzasNotificacion,
} from '../../actions/CobranzasAction.js';
import { RegistrarAccion } from '../../actions/AuditoriaAction.js';
import { EditorState, ContentState, convertFromHTML,convertToRaw  } from 'draft-js';
import draftToHtml from "draftjs-to-html";
export default function PerfilTarea(props) {
  const mounted = useRef(true);
  const history = useHistory();
  //eslint-disable-next-line
  const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();
  const [openModal, setOpenModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [cierre, setCierre] = useState({
    MOTIVODECIERRE: '',
  });
  const [DataPresu, setDataPresu] = useState([]);
  const [estadoBotonTelefono, setEstadoBotonTelefono] = useState(true);
  const [Datatel, setDatatel] = useState([]);
  const [Datadir, setDatadir] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [mostrarFact, setMostrarFac] = useState(false);
  const [estadoBotonDirecciones, setEstadoBotonDirecciones] = useState(true);
  const [tarea, setTarea] = useState({
    TAREA_ID: '',
    CODTAREA: 0,
    USUARIOASIGNADO: '',
    CLIENTE_ID: '',
    FECHACREACION: '',
    FECHAVTO: '',
    TIPOTAREA: '',
    NUMTAREA: '',
    CLIENTE: '',
    CODPRESUPUESTO: '',
  });
  const [term, setTerm] = useState('');
  const [contenido, setContenido] = useState('');

  // const [editorValue, setEditorValue] = useState(
  //   Editor.createValueFromString(contenido, 'html')
  // );
  const createEditorStateFromHTML = (html) => {
  const blocksFromHTML = convertFromHTML(html || '');
  const contentState = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap
  );
  return EditorState.createWithContent(contentState);
};

const [editorValue, setEditorValue] = useState(() =>
  createEditorStateFromHTML(contenido)
);


const handleChange = (value) => {
  setEditorValue(value);

  const raw = convertToRaw(value.getCurrentContent());
  // const html = draftToHtml(raw);

  // setContenido(html);
  const text = value.getCurrentContent().getPlainText();
setContenido(text);

};
  const abrirPosiblecobro = () => {
    let fact = facturas;
    fact['tarea_id'] = tarea.TAREA_ID;
    fact['cliente_id'] = tarea.CLIENTE_ID;
    fact['user'] = '';
    if (props.location.state.perfilCobrador) {
      fact['user'] = 'COBRADOR';
    }
    history.push({
      pathname: '/gestionarPosibleCobro',
      state: fact,
    });
  };
  const body = (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: 1000,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        outline: 0,
        maxHeight: '90vh',
        overflow: 'auto',
      }}
    >
      <Typography
        variant="h5"
        sx={{ mb: 3, fontWeight: 600, color: 'primary.main' }}
      >
        Historial de Tareas del Presupuesto
      </Typography>

      <TextField
        name="termc"
        fullWidth
        sx={{ mb: 3 }}
        onChange={(e) => setTerm(e.target.value)}
        label="Buscar"
        variant="outlined"
        InputProps={{
          startAdornment: (
            <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
              <SearchIcon color="action" />
            </Box>
          ),
        }}
      />
      <div notranslate="true">
        <TTareas
          rows={DataPresu}
          termc={term}
          history={props.history}
          id={'Visitante'}
        />
      </div>
    </Box>
  );
  const mostrarDirecciones = () => {
    if (estadoBotonDirecciones === false) {
      setEstadoBotonDirecciones(true);
    } else {
      setEstadoBotonDirecciones(false);
    }
  };
  const mostrarTelefonos = () => {
    if (estadoBotonTelefono === false) {
      setEstadoBotonTelefono(true);
    } else {
      setEstadoBotonTelefono(false);
    }
  };
  //RR: ABRE EL DIALOG DE MOTIVO DE CIERRE
  const dialogHandleClickOpen = () => {
    setOpenDialog(true);
  };
  //RR: CIERRA EL DIALOG DE MOTIVO DE CIERRE
  const dialogHandleClose = () => {
    setOpenDialog(false);
    setCierre({
      MOTIVODECIERRE: '',
    });
  };
  //RR: FUNCION PARA BOTON CERRAR Y NUEVO
  // const cerrarTareaYNueva = (e) => {
  //   if (contenido !== '') {
  //     e.preventDefault();
  //     let fecha = moment().format().toString().substr(0, 16) + ':00';
  //     const id = tarea.TAREA_ID;
  //     const objetoCierre = {
  //       COMPLETADO: fecha,
  //       MOTIVOCANCELACION: contenido,
  //     };
  //     editarTarea(id, objetoCierre).then((response) => {
  //       if (response.status === 200) {
  //         dispatch({
  //           type: 'OPEN_SNACKBAR',
  //           openMensaje: {
  //             open: true,
  //             mensaje: 'Se cerro exitosamente la Tarea',
  //           },
  //         });
  //         let objetoNoti = {
  //           USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
  //           UserName: sesionUsuario.usuario.userName,
  //         };
  //         if (
  //           props.location.state.presupuesto === null ||
  //           props.location.state.presupuesto === undefined
  //         ) {
  //           obtenerTareasNotificacion(objetoNoti);
  //           obtenerCobranzasNotificacion(objetoNoti);
  //           dialogHandleClose();
  //           setTarea({
  //             TAREA_ID: '',
  //             CODTAREA: 0,
  //             USUARIOASIGNADO: '',
  //             CLIENTE_ID: tarea.CLIENTE_ID,
  //             FECHACREACION: '',
  //             FECHAVTO: '',
  //             TIPOTAREA: '',
  //             NUMTAREA: '',
  //             CLIENTE: '',
  //             CODPRESUPUESTO: '',
  //           });
  //           setCierre({
  //             MOTIVODECIERRE: '',
  //           });
  //           setContenido('');
  //         //  setEditorValue(Editor.createValueFromString(contenido, 'html'));
  //           setEditorValue(createEditorStateFromHTML(contenido));

  //           /*RRR: verifica si la tarea cuenta con facturas para poder enviarlas al componente 
  //           tarea nueva y arma el estado para que cumpla con los requisitos
  //           puesto que aqui enviamos en base a una tarea ya creada y no una tarea con facturas 
  //           desde cero */
  //           if (
  //             props.location.state.facturas &&
  //             props.location.state.facturas.length !== 0
  //           ) {
  //             tarea['NTfacturas'] = true;
  //             tarea['facturasNT'] = props.location.state.facturas;
  //           }
  //           history.push({ pathname: '/nuevaTarea', state: tarea });
  //         } else {
  //           obtenerPresupuestoPorId(
  //             props.location.state.presupuesto.presupuestO_Id
  //           ).then((response) => {
  //             if (response.status === 200) {
  //               response.data[0]['TipoVisitante'] = 'Propietario';
  //               history.push({
  //                 pathname: '/nuevaTarea',
  //                 state: response.data[0],
  //               });
  //               setTarea({
  //                 TAREA_ID: '',
  //                 CODTAREA: 0,
  //                 USUARIOASIGNADO: '',
  //                 CLIENTE_ID: tarea.CLIENTE_ID,
  //                 FECHACREACION: '',
  //                 FECHAVTO: '',
  //                 TIPOTAREA: '',
  //                 NUMTAREA: '',
  //                 CLIENTE: '',
  //                 CODPRESUPUESTO: '',
  //               });
  //               setCierre({
  //                 MOTIVODECIERRE: '',
  //               });
  //               setContenido('');
  //             //  setEditorValue(Editor.createValueFromString(contenido, 'html'));
  //               setEditorValue(createEditorStateFromHTML(contenido));

  //               let objetoAudi = {
  //                 usuario: sesionUsuario.usuario.nombrecompleto,
  //                 accion: 'Modificacion',
  //                 panel: 'Gestion de Tareas',
  //                 tabla: 'TAREAS',
  //                 filaafectada: props.location.state.TAREA_ID,
  //                 UsuarioId: sesionUsuario.usuario.id,
  //               };
  //               RegistrarAccion(objetoAudi);
  //               obtenerTareasNotificacion(objetoNoti);
  //               obtenerCobranzasNotificacion(objetoNoti);
  //               dialogHandleClose();
  //             }
  //           });
  //         }
  //         if (
  //           props.location.state !== undefined &&
  //           props.location.state.perfilCobrador
  //         ) {
  //           let objeto = {
  //             estado: 'PDB',
  //           };
  //           props.location.state.facturas.map((factura) => {
  //             modificarFactura(factura.id, objeto).then((response) => {
  //               if (response.status === 200) {
  //                 console.log('FACTURA CAMBIADA');
  //               }
  //             });
  //             return null;
  //           });
  //         }
  //       } else {
  //         dispatch({
  //           type: 'OPEN_SNACKBAR',
  //           openMensaje: {
  //             open: true,
  //             mensaje: 'Errores al intentar guardar ',
  //           },
  //         });
  //       }
  //     });
  //   } else {
  //     dispatch({
  //       type: 'OPEN_SNACKBAR',
  //       openMensaje: {
  //         open: true,
  //         mensaje: 'DEBE AGREGAR UN MOTIVO DE CIERRE',
  //       },
  //     });
  //   }
  // };
  //RRR: FUNCION PARA CERRAR TAREA
  // const cerrarTarea = (e) => {
  //   if (contenido !== '') {
  //     e.preventDefault();
  //     let fecha = moment().format().toString().substr(0, 16) + ':00';
  //     const id = tarea.TAREA_ID;
  //     const objetoCierre = {
  //       COMPLETADO: fecha,
  //       MOTIVOCANCELACION: contenido,
  //     };
  //     editarTarea(id, objetoCierre).then((response) => {
  //       if (response.status === 200) {
  //         dispatch({
  //           type: 'OPEN_SNACKBAR',
  //           openMensaje: {
  //             open: true,
  //             mensaje: 'Se cerro exitosamente la Tarea',
  //           },
  //         });
  //         let objetoNoti = {
  //           USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
  //           UserName: sesionUsuario.usuario.userName,
  //         };
  //         obtenerTareasNotificacion(objetoNoti);
  //         obtenerCobranzasNotificacion(objetoNoti);
  //         setTarea({
  //           TAREA_ID: '',
  //           CODTAREA: 0,
  //           USUARIOASIGNADO: '',
  //           CLIENTE_ID: '',
  //           FECHACREACION: '',
  //           FECHAVTO: '',
  //           TIPOTAREA: '',
  //           NUMTAREA: '',
  //           CLIENTE: '',
  //           CODPRESUPUESTO: '',
  //         });
  //         setCierre({
  //           MOTIVODECIERRE: '',
  //         });
  //         setContenido('');
  //       //  setEditorValue(Editor.createValueFromString(contenido, 'html'));
  //       setEditorValue(createEditorStateFromHTML(contenido));

  //         let objetoAudi = {
  //           usuario: sesionUsuario.usuario.nombrecompleto,
  //           accion: 'Modificacion',
  //           panel: 'Gestion de Tareas',
  //           tabla: 'TAREAS',
  //           filaafectada: props.location.state.TAREA_ID,
  //           UsuarioId: sesionUsuario.usuario.id,
  //         };
  //         if (
  //           props.location.state !== undefined &&
  //           props.location.state.perfilCobrador
  //         ) {
  //           let objeto = {
  //             estado: 'PDB',
  //           };
  //           props.location.state.facturas.map((factura) => {
  //             modificarFactura(factura.id, objeto).then((response) => {
  //               if (response.status === 200) {
  //                 console.log('FACTURA CAMBIADA');
  //               }
  //             });
  //             return null;
  //           });
  //         }
  //         RegistrarAccion(objetoAudi);
  //         dialogHandleClose();
  //         volver();
  //       } else {
  //         dispatch({
  //           type: 'OPEN_SNACKBAR',
  //           openMensaje: {
  //             open: true,
  //             mensaje: 'Errores al intentar guardar ',
  //           },
  //         });
  //       }
  //     });
  //   } else {
  //     dispatch({
  //       type: 'OPEN_SNACKBAR',
  //       openMensaje: {
  //         open: true,
  //         mensaje: 'DEBE AGREGAR UN MOTIVO DE CIERRE ',
  //       },
  //     });
  //   }
  // };
  const cerrarTarea = (e) => {
  e.preventDefault();
  if (contenido.trim() === '') {
    dispatch({
      type: 'OPEN_SNACKBAR',
      openMensaje: {
        open: true,
        mensaje: 'Debe agregar un motivo de cierre.',
      },
    });
    return;
  }

  let fecha = moment().format('YYYY-MM-DDTHH:mm:ss');
  const id = tarea.TAREA_ID;
  const objetoCierre = {
    COMPLETADO: fecha,
    MOTIVOCANCELACION: contenido,
  };

  editarTarea(id, objetoCierre).then((response) => {
    if (response.status === 200) {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: ' Se cerró exitosamente la tarea',
        },
      });

      // Notificaciones base
      const objetoNoti = {
        USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
        UserName: sesionUsuario.usuario.userName,
      };
      obtenerTareasNotificacion(objetoNoti);
      obtenerCobranzasNotificacion(objetoNoti);

      // Auditoría (siempre)
      const objetoAudi = {
        usuario: sesionUsuario.usuario.nombrecompleto,
        accion: 'Modificación',
        panel: 'Gestión de Tareas',
        tabla: 'TAREAS',
        filaafectada: id,
        UsuarioId: sesionUsuario.usuario.id,
      };
      RegistrarAccion(objetoAudi);

      // Si tiene facturas y el perfil es cobrador → modificar estado
      if (
        props.location.state?.perfilCobrador &&
        Array.isArray(props.location.state.facturas)
      ) {
        props.location.state.facturas.forEach((factura) => {
          modificarFactura(factura.id, { estado: 'PDB' }).then((resp) => {
            if (resp.status === 200) {
              console.log(`Factura ${factura.id} cambiada a PDB`);
            }
          });
        });
      }

      // Limpieza y volver
      setContenido('');
      setEditorValue(createEditorStateFromHTML(''));
      setCierre({ MOTIVODECIERRE: '' });
      dialogHandleClose();
      volver();
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: ' Error al intentar cerrar la tarea.',
        },
      });
    }
  });
};

  const volver = () => {
    props.history.goBack();
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const abrirModalHistorialPresu = () => {
    setOpenModal(true);
  };
  useEffect(() => {
     console.log('STATE RECIBIDO:', props.location.state);
    if (mounted.current) {
      /*RRR: esta es una serie de verificaciones que debe hacer el modulo para 
      identificar si el perfil solicitado es de una tarea con 
      presupuestos o con facturas*/
      setTarea({
        TAREA_ID: props.location.state.tareA_Id,
        CODTAREA: props.location.state.codtarea,
        USUARIOASIGNADO: props.location.state.usuarioasignado,
        CLIENTE_ID:
          props.location.state.cliente !== null
            ? props.location.state.cliente.clientE_Id
            : props.location.state.posiblecliente.posibleclientE_Id,
        FECHACREACION: props.location.state.fechacreacion,
        FECHAVTO: props.location.state.fechavto,
        /*RRR: Este comparador ternario se utiliza por que las tareas que tienen facturas vienen desde una vista 
        no de una consulta directa con entityframework por lo tanto algunos items son string planos y no 
        objetos como devuelve entity a las tablas relacionadas*/
        TIPOTAREA: typeof props.location.state.tipotarea === 'object'
  ? (props.location.state.tipotarea?.descritipotarea || '')
  : (props.location.state.tipotarea || ''),
        NUMTAREA: props.location.state.numtarea,
        CLIENTE:
    props.location.state.cliente === null
      ? props.location.state.posiblecliente.nombre +
        ' ' +
        props.location.state.posiblecliente.apellido
      : typeof props.location.state.cliente === 'object'
      ? (props.location.state.cliente.nombre || '') +
        ' ' +
        (props.location.state.cliente.apellido || '')
      : props.location.state.cliente || '',
        CODPRESUPUESTO: props.location.state.presupuesto
          ? props.location.state.presupuesto.codpresupuesto
          : '',
      });
      /*RRR: verifica si la tarea ya esta cerrada para mostrar el motivo de cancelacion
      y ocultarlo en caso de que aun este pendiente de cierre*/
      if (props.location.state.motivocancelacion !== null) {
        setCierre({
          MOTIVODECIERRE: props.location.state.motivocancelacion,
        });
      } /*RRR: verifica si la tarea contiene un presupuesto para mostrar el historial de tareas del presupuesto */ else if (
        props.location.state.presupuesto !== null &&
        props.location.state.presupuesto !== undefined
      ) {
        obtenerTareasPresupuestoG(
          props.location.state.presupuesto.presupuestO_Id
        ).then((response) => {
          if (response.status === 200) {
           // setDataPresu(response.data);
           setDataPresu(Array.isArray(response.data) ? response.data : []);

          }
        });
        /*RRR:verifica si la tarea contiene facturas las cuales se envian desde el componente solicitante 
        en el state del location y habilita los campos necesarios para mostrar las facturas en el perfil */
      } else if (
        props.location.state.facturas &&
        props.location.state.facturas.length !== 0
      ) {
        setFacturas(props.location.state.facturas);
        setMostrarFac(true);
      } else {
        console.log('NO CUMPLIO NI UNO');
      }

      obtenerTelefonosTareas(props.location.state.tareA_Id).then((response) => {
        const Data = response.data;
        setDatatel(Data);
      });
      obtenerDireccionesTareas(props.location.state.tareA_Id).then(
        (response) => {
          const Data = response.data;
          setDatadir(Data);
        }
      );
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [props, sesionUsuario]);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con gradiente */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 4,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
            }}
          >
            <AssignmentIcon sx={{ fontSize: 32, color: 'white' }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ color: 'white', fontWeight: 600 }}>
              Perfil de Tarea #{tarea.CODTAREA}
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.9)' }}>
              {tarea.TIPOTAREA}
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Información de la Tarea */}
      <Paper
        elevation={0}
        sx={{
          p: 4,
          mb: 3,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="h6" sx={{ mb: 4, fontWeight: 600 }}>
          Información de la Tarea
        </Typography>
        <form>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <TextField
                multiline
                name="CODTAREA"
                value={tarea.CODTAREA}
                fullWidth
                variant="outlined"
                label="CODIGO"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                multiline
                name="USUARIOASIGNADO"
                value={tarea.USUARIOASIGNADO}
                fullWidth
                variant="outlined"
                label="USUARIO ASIGNADO"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                multiline
                name="FECHACREACION"
                value={tarea.FECHACREACION.substr(-20, 10)}
                fullWidth
                variant="outlined"
                label="FECHA DE CREACION"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                multiline
                name="FECHAVTO"
                value={tarea.FECHAVTO.substr(-20, 10)}
                fullWidth
                variant="outlined"
                label="FECHA DE VENCIMIENTO"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="HORAPACTADA"
                value={tarea.FECHAVTO.substr(-8, 5)}
                fullWidth
                variant="outlined"
                label="Hora Pactada"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                      <ScheduleIcon sx={{ color: 'action.active', fontSize: 20 }} />
                    </Box>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="CLIENTE"
                value={tarea.CLIENTE}
                fullWidth
                variant="outlined"
                label="Cliente"
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
                      <PersonIcon sx={{ color: 'action.active', fontSize: 20 }} />
                    </Box>
                  ),
                }}
              />
            </Grid>
            {tarea.CODPRESUPUESTO !== '' ? (
              <Grid item xs={12}>
                <TextField
                  name="CODPRESUPUESTO"
                  value={tarea.CODPRESUPUESTO}
                  fullWidth
                  variant="outlined"
                  label="Código del Presupuesto"
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{ mb: 2 }}
                />

                <Button
                  variant="contained"
                  startIcon={<HistoryIcon />}
                  onClick={abrirModalHistorialPresu}
                  sx={{
                    borderRadius: 2,
                    textTransform: 'none',
                    fontWeight: 600,
                  }}
                >
                  Ver Historial del Presupuesto
                </Button>
              </Grid>
            ) : null}
            {mostrarFact ? <TFacturasTareas DataFact={facturas} /> : null}
            <Grid item xs={12}>
              <TextField
                name="TIPOTAREA"
                value={tarea.TIPOTAREA}
                fullWidth
                variant="outlined"
                label="Tipo de Tarea"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
              Detalles:
            </Typography>
            <TextField
              name="NUMTAREA"
              value={tarea.NUMTAREA}
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              placeholder="Detalles de la tarea"
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              startIcon={<PhoneIcon />}
              onClick={mostrarTelefonos}
              sx={{
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              {estadoBotonTelefono ? 'Ocultar' : 'Ver'} Teléfonos
            </Button>
          </Box>
          {estadoBotonTelefono === true && Datatel.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <TableContainer component={Paper} sx={{ border: '1px solid', borderColor: 'divider' }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: 'action.hover' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Teléfonos</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Detalles</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Datatel.map((telefono) => (
                      <TableRow key={telefono.telefonotareA_Id}>
                        <TableCell>{telefono.descritelefonotarea}</TableCell>
                        <TableCell>{telefono.detallestelefonotarea}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              startIcon={<LocationOnIcon />}
              onClick={mostrarDirecciones}
              sx={{
                py: 1.5,
                borderRadius: 2,
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              {estadoBotonDirecciones ? 'Ocultar' : 'Ver'} Direcciones
            </Button>
          </Box>
          {estadoBotonDirecciones === true ? (
            <TableContainer component={Paper} align="center">
              <Table size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Direcciones</TableCell>
                    <TableCell align="left">Detalles</TableCell>
                    <TableCell align="left">Barrios</TableCell>
                    <TableCell align="left">Ciudades</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Datadir.map((direccion) => (
                    <TableRow key={direccion.direccioN_Id}>
                      <TableCell align="left">
                        {direccion.descridireccion}
                      </TableCell>
                      <TableCell align="left">
                        {direccion.detallesdireccion}
                      </TableCell>
                      <TableCell align="left">
                        {direccion.barrio.describarrio}
                      </TableCell>
                      <TableCell align="left">
                        {direccion.ciudad.descriciudad}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
          <br />
          {props.location.state.motivocancelacion ? (
            <Grid container>
              <Grid item xs={12} md={12}>
                <Typography>Motivo de Cierre:</Typography>
                <br />
                <Editor
  placeholder="Escribir aquí..."
  editorState={createEditorStateFromHTML(cierre.MOTIVODECIERRE)}
  toolbarHidden={true}
  readOnly={true}
  editorStyle={{ height: 200 }}
  wrapperStyle={{ width: '100%' }}
/>

              </Grid>
              <br />
            </Grid>
          ) : null}
          {/*RRR: se verifica si la persona que entra al perfil es el creador de la tarea
          puesto a que el unico que puede cerrar una tarea es el propietaro(asignado)
          y nadie mas
          */}
          {props.location.state.TipoVisitante === 'Propietario' &&
          props.location.state.completado === null ? (
            <Box sx={{ display: 'flex', gap: 2, mt: 4, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="error"
                startIcon={<CloseIcon />}
                onClick={dialogHandleClickOpen}
                sx={{
                  flex: 1,
                  minWidth: 200,
                  borderRadius: 2,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Cerrar Tarea
              </Button>
              <Button
                onClick={volver}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                sx={{
                  flex: 1,
                  minWidth: 200,
                  borderRadius: 2,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Cancelar
              </Button>
              {mostrarFact === true &&
              (props.location.state === undefined ||
                !props.location.state.perfilCobrador) && (
                <Button
                  variant="contained"
                  startIcon={<AttachMoneyIcon />}
                  onClick={abrirPosiblecobro}
                  sx={{
                    flex: 1,
                    minWidth: 200,
                    borderRadius: 2,
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 600,
                    backgroundColor: '#1b5e20',
                    '&:hover': {
                      backgroundColor: '#2e7d32',
                    },
                  }}
                >
                  Gestionar Posible Cobro
                </Button>
              )}
              {mostrarFact === true &&
              props.location.state !== undefined &&
              props.location.state.perfilCobrador && (
                <Button
                  variant="contained"
                  startIcon={<AttachMoneyIcon />}
                  onClick={abrirPosiblecobro}
                  sx={{
                    flex: 1,
                    minWidth: 200,
                    borderRadius: 2,
                    py: 1.5,
                    textTransform: 'none',
                    fontWeight: 600,
                    backgroundColor: '#1b5e20',
                    '&:hover': {
                      backgroundColor: '#2e7d32',
                    },
                  }}
                >
                  Gestionar Cobro
                </Button>
              )}
            </Box>
          ) : (
            <Box sx={{ mt: 4, textAlign: 'center' }}>
              <Button
                onClick={volver}
                variant="contained"
                startIcon={<ArrowBackIcon />}
                sx={{
                  minWidth: 200,
                  borderRadius: 2,
                  py: 1.5,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Volver
              </Button>
            </Box>
          )}
        </form>
      </Paper>
      <div notranslate="true">
        <Dialog
          open={openDialog}
          onClose={dialogHandleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Alerta</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Debe agregar un motivo del cierre.
            </DialogContentText>
<Editor
  placeholder="Escribir aquí..."
  editorState={editorValue}
  onEditorStateChange={handleChange}
  wrapperStyle={{ width: 500 }}
  editorStyle={{ height: 200 }}
/>


          </DialogContent>
          <DialogActions>
            <Button
              onClick={dialogHandleClose}
              variant="contained"
              color="secondary"
            >
              Cancelar
            </Button>
            {/* <Button
              variant="contained"
              onClick={cerrarTareaYNueva}
              color="primary"
            >
              Cerrar y Crear Nueva Tarea
            </Button> */}
            <Button variant="contained" onClick={cerrarTarea} color="primary">
              Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Modal open={openModal} onClose={handleCloseModal}>
        {body}
      </Modal>
    </Container>
  );
}
